(function () {
    'use strict';

    angular.module('thankview.freeTrial', ['ngTouch', 'thankview.global']);
}());
